import React, { forwardRef, PropsWithChildren } from "react";
import { _ContainerRoot } from "./Container.styled";
import clsx from "clsx";

export interface ContainerProps {
  style?: React.CSSProperties;
  className?: string;
  bg?: string;
  mt?: React.CSSProperties["marginTop"];
  mb?: React.CSSProperties["marginBottom"];
  as?: React.ComponentType<any> | string;
  [p: string]: any;
  maxWidth?: number | string;
}

const Container = forwardRef(
  (props: PropsWithChildren<ContainerProps>, ref) => {
    const { children, bg, style, className, mt, mb, as } = props;

    return (
      <_ContainerRoot
        {...{
          ref,
          style,
          as,
          className: clsx("ro-container", className),
          $bg: bg,
          $mt: mt,
          $mb: mb,
          $maxWidth: props.maxWidth,
        }}
      >
        {children}
      </_ContainerRoot>
    );
  }
);

export default Container;
